import React from 'react';
import { Link } from 'react-router-dom';

const About = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-gray-900 mb-6">About RankTheBlank.js</h1>
      
      <div className="prose prose-indigo prose-lg text-gray-500 mx-auto">
        <p>
          RankTheBlank.js is an educational platform designed to help people understand and experience 
          the benefits of ranked choice voting systems. We believe that better voting methods lead to better outcomes,
          whether you're deciding on lunch options or electing officials.
        </p>
        
        <h2>Our Mission</h2>
        <p>
          Our mission is to make ranked choice voting accessible and understandable to everyone. By providing a simple,
          intuitive interface for creating and participating in ranked choice polls, we help users see firsthand how 
          this voting system works and the advantages it offers over traditional voting methods.
        </p>
        
        <h2>About Single Transferable Vote (STV)</h2>
        <p>
          The Single Transferable Vote (STV) system is a form of ranked choice voting designed to ensure that votes are not wasted
          and that the final result better reflects the preferences of all voters. Here's how it works:
        </p>
        
        <ol>
          <li>Voters rank candidates in order of preference.</li>
          <li>A quota is established for winning (the minimum number of votes needed).</li>
          <li>First preferences are counted. Any candidate who meets the quota is elected.</li>
          <li>If a candidate has more votes than needed (surplus), those excess votes are transferred to the voters' next preferences.</li>
          <li>If no candidate meets the quota, the candidate with the fewest votes is eliminated, and those votes are transferred according to the next preferences.</li>
          <li>This process continues until all seats are filled or until there are as many candidates remaining as seats to be filled.</li>
        </ol>
        
        <h2>Why Use Ranked Choice Voting?</h2>
        <p>
          Ranked choice voting has several advantages over traditional "first-past-the-post" voting:
        </p>
        
        <ul>
          <li>It eliminates the "spoiler effect" where similar candidates split votes.</li>
          <li>It ensures winners have broader support, not just a plurality.</li>
          <li>It allows voters to express their full preferences without strategic voting.</li>
          <li>It tends to reduce negative campaigning since candidates want to be voters' second and third choices.</li>
          <li>It provides more information about voter preferences than simple yes/no votes.</li>
        </ul>
        
        <h2>Contact Us</h2>
        <p>
          Have questions or feedback? We'd love to hear from you! Please contact us at support@ranktheblank.js
        </p>
        
        <div className="mt-8 flex">
          <Link
            to="/"
            className="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default About;